interface props {
  key: number;
  title: string;
  src: string;
  alt: string;
  url: string;
  description: string;
  tag: string[];
}

export default function ProjectTile(Props: props) {
  return (
    <div className="ProjectTile">
      <h3 id="titlePT">{Props.title}</h3>
      <a id="aPT" href={Props.url}>
        <img src={Props.src} alt={Props.alt} className="imgPT" />
      </a>
      <small id="smPT">{Props.description}</small>
      <div className="TagContainer">
        {Props.tag.map((oneTag, index) => (
          <div className="OneTag" key={index}>
            {oneTag}
          </div>
        ))}
      </div>
    </div>
  );
}
